import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
interface NavButtonProps {
  label: string;
  isActive?: boolean;
  to: string;
  index: number;
}
export function NavButton({
  label,
  isActive = false,
  to,
  index
}: NavButtonProps) {
  return <Link to={to} className="block relative w-36 h-10 group focus:outline-none" data-id="element-172">
      <motion.div className="w-full h-full" whileHover={{
      scale: 1.05,
      x: 5
    }} whileTap={{
      scale: 0.95
    }} initial={{
      opacity: 0,
      x: -30
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      delay: index * 0.08
    }} data-id="element-173">
        {/* Simple rectangle with border */}
        <div className={`absolute inset-0 border-2 border-black transition-colors duration-200`} style={{
        backgroundColor: isActive ? '#d4c96a' : '#E5D68A'
      }} data-id="element-174">
          {/* Text Content */}
          <span className="flex items-center justify-center h-full px-3 text-xs font-bold tracking-tight text-black font-mono uppercase" data-id="element-175">
            {label}
          </span>
        </div>
      </motion.div>
    </Link>;
}